import { createContext } from '@lit/context';

export type FlagSet = Record<string, boolean>;

export const flagContext = createContext<FlagSet>('featureFlags');
